/**
 * Will act as the default wrapper for all module states within the application
 * that call it within their own Layouts
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import CMBuildTopNav from './CMBuildTopNav.js.jsx';

const CMPreviewLayout = (props) => {
  return (
    <div className="tm-build-layout">
      <CMBuildTopNav />
      {props.children}
    </div>
  )
}

export default CMPreviewLayout;



// WEBPACK FOOTER //
// modules/contentModule/components/CMBuildLayout.js.jsx